const modifiedFields = ['widgetName'];
const modifiedFieldCustom = {};
const sortByFields = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };